// The `getStepNumber` function decides what number to show for each step.
// If the app has only one stage and the step number is more than 0, it uses that number.
// If the app has multiple stages, it adds 1 to the step number.
// This makes sure the steps are numbered right, whether there's one stage or more.
const getStepNumber = (isMultiStage: boolean, baseIndex: number): number => {
  if (!isMultiStage && baseIndex > 0) {
    return baseIndex
  }

  return baseIndex + 1
}

type StepNumberProps = {
  isMultiStage: boolean
  baseIndex: number
}

// This component shows the step number in a custom way because the default Mantine Stepper can crash the app when using Google Chrome Translate.
// To avoid crashes, we wrap the step number in a <span>.
// For more details, see the issue: https://github.com/mantinedev/mantine/issues/6364.
export const StepNumber = ({ isMultiStage, baseIndex }: StepNumberProps) => (
  <span>{getStepNumber(isMultiStage, baseIndex)}</span>
)
